import styled from 'styled-components';
import BackButton from '../utils/back_button';
import { blog4 } from "../../../assets/images";
import { useNavigate } from 'react-router-dom';
import OtherBlogs from '../our_blogs/OtherBlogs';
import CTASection from "../../landing/landing_home/empower"

const Blog4 = () => {
  return (
    <>
     <Fullpage>
     <PageBackground>
     <BlogContainer>
      <ContentWrapper>
        <BlogHeader />
        <HeroImage
          src={blog4}
          alt="Campus Insights AI-Powered Student Recruitment"
        />
        <BlogContent />
      </ContentWrapper>
      </BlogContainer>
      <OtherBlogs currentBlogId={4} />
      </PageBackground>
      </Fullpage>
      <CTASection />
    </>
  );
};

const BlogHeader = () => {
     const navigate = useNavigate();
      const handleBackClick = () => {
         window.scrollTo(0, 0);
         navigate("/blog")
      };
    
  return (
    <HeaderContainer>
      <BackButtonWrapper>
         <BackButton onClick={handleBackClick} />
      </BackButtonWrapper>
      <MainTitle>
        Boosting Student Recruitment with Campus Insights
        <br />
        AI-Powered Engagement That Converts
      </MainTitle>
      <MetadataContainer>
        <MetadataWrapper>
           <DateText>August 1, 2025</DateText>
        <AuthorText>posted by campus insights</AuthorText>
        </MetadataWrapper>
      </MetadataContainer>
     
    </HeaderContainer>
  );
};

const BlogContent = () => {
  return (
    <ContentContainer>
      <ContentSection title="🌐 The Recruitment Challenge" isMainHeading>
        <BodyText>
          Prospective students today expect fast, personalized, and
          digital-first experiences—yet most institutions still rely on static
          websites, delayed responses, and one-size-fits-all outreach.
        </BodyText>
        <BodyText>
          Campus Insights transforms recruitment by combining AI-powered chat,
          data intelligence, and multilingual support to engage, convert, and
          enroll students faster.
        </BodyText>
      </ContentSection>

      <ContentSection title="🚀 Key Ways Campus Insights Supports Recruitment" isMainHeading>
        <SubSection>
          <SubHeading>1. 24/7 Instant Engagement</SubHeading>
          <BodyText>
            AI-powered chatbots answer student questions instantly—day or
            night—on admissions, deadlines, program fit, campus life, and
            financial aid. No more waiting for office hours or email replies.
          </BodyText>
          <ExampleText>
            "Can I apply with a GED?" → Answered immediately with links and
            guidance.
          </ExampleText>
        </SubSection>

        <SubSection>
          <SubHeading>2. Personalized Recruitment Journeys</SubHeading>
          <BodyText>
            Students are guided based on interests, demographics, and intent
            signals. The system adapts messaging for transfer, international,
            adult learners, or first-gen students.
          </BodyText>
          <ExampleText>
            "You mentioned nursing—here's a virtual tour of our Health Sciences
            building + info session registration."
          </ExampleText>
        </SubSection>

        <SubSection>
          <SubHeading>3. Multilingual Outreach</SubHeading>
          <BodyText>
            Supports 100+ languages to engage students and families in their
            preferred language—building trust and removing access barriers for
            non-native English speakers.
          </BodyText>
        </SubSection>

        <SubSection>
          <SubHeading>4. Data-Driven Lead Conversion</SubHeading>
          <BodyText>
            Track which messages, topics, and touchpoints drive inquiries, event
            attendance, and applications. Campus Insights helps recruiters
            prioritize high-intent leads and follow up faster.
          </BodyText>
          <ExampleText>
            See which students asked about scholarships but haven't yet started
            an application.
          </ExampleText>
        </SubSection>

        <SubSection>
          <SubHeading>5. CRM &amp; Website Integration</SubHeading>
          <BodyText>
            Seamlessly connects with existing enrollment CRMs and websites to
            auto-log interactions, track behavior, and create a unified prospect
            profile.
          </BodyText>
        </SubSection>

        <SubSection>
          <SubHeading>6. Event Boosting &amp; Funnel Support</SubHeading>
          <BodyText>
            Promotes open houses, webinars, and deadlines through conversational
            reminders—ensuring prospects don't drop out of the funnel due to
            missed opportunities.
          </BodyText>
        </SubSection>
      </ContentSection>

      <ContentSection title="📈 Recruitment Results You Can Expect" isMainHeading>
        <IntroText>
          Institutions using Campus Insights for recruitment see:
        </IntroText>
        <ResultsList>
          <ResultItem>Higher inquiry-to-application conversion</ResultItem>
          <ResultItem>Increased response rates from prospective students</ResultItem>
          <ResultItem>
            Improved engagement from underserved &amp; multilingual populations
          </ResultItem>
          <ResultItem>
            Greater staff efficiency in outreach and lead management
          </ResultItem>
          <ResultItem>
            Stronger brand perception among digital-native prospects
          </ResultItem>
        </ResultsList>
        <ConclusionText>
          Campus Insights meets students where they are—with the answers they
          need, the moment they need them—driving stronger recruitment outcomes.
        </ConclusionText>
      </ContentSection>
    </ContentContainer>
  );
};

const ContentSection = ({ title, children, isMainHeading = false }) => {
  return (
    <SectionContainer>
      {isMainHeading ? (
        <MainHeading>{title}</MainHeading>
      ) : (
        <SectionHeading>{title}</SectionHeading>
      )}
      <ContentWrapper1>{children}</ContentWrapper1>
    </SectionContainer>
  );
};


const MetadataContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const MetadataWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const MainHeading = styled.h2`
  width: 100%;
  color: #1c1b1f;
  letter-spacing: -0.32px;
  font: 700 32px/120% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 28px;
  }
  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

const SectionHeading = styled.h3`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.2px;
  font: 400 20px/140% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 18px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const ContentWrapper1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const SubHeading = styled.h4`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.2px;
  font: 400 20px/140% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 18px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const BodyText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const ExampleText = styled.p`
  width: 100%;
  color: #64636a;
  text-align: center;
  letter-spacing: -0.08px;
  font: 700 16px/160% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const IntroText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.2px;
  font: 400 20px/140% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 18px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const ResultsList = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ResultItem = styled.li`
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, sans-serif;
  position: relative;
  padding-left: 20px;

  &:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #64636a;
  }

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const ConclusionText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;


const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const BackButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const MainTitle = styled.h1`
  width: 100%;
  color: #1c1b1f;
  letter-spacing: -0.32px;
  margin: 0 0 20px 0;
  font: 700 48px/120% Inter, sans-serif;
  @media (max-width: 991px) {
    font-size: 36px;
  }
  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 130%;
  }
`;

const DateText = styled.time`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 400 16px/120% Inter, sans-serif;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const AuthorText = styled.span`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 400 16px/120% Inter, sans-serif;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;


const BlogContainer = styled.article`
  display: flex;
  width: 100%;
  max-width: 1120px;
  padding: 56px;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  border-radius: 24px;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: #fff;
  @media (max-width: 991px) {
    padding: 40px;
    gap: 48px;
  }
  @media (max-width: 640px) {
    padding: 24px;
    gap: 32px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  width: 100%;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 400px;
  border-radius: 16px;
  object-fit: cover;
  @media (max-width: 991px) {
    height: 300px;
  }
  @media (max-width: 640px) {
    height: 200px;
  }
`;

const PageBackground = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 500px, #F5F5F9 100px, #F5F5F9 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 200px 0;
    flex-direction: column;

  @media (max-width: 640px) {
    padding: 40px 0;
    background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 100px, #ffffff 100px, #ffffff 100%);
  }
`;

const Fullpage = styled.div`
  height: 100%;
  width: 100%;
//   background-color: #e20707ff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
 

  @media (max-width: 640px) {
    padding: 40px 0;
   
  }
`;

export default Blog4;
